import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getInfoPaneItemExternalLinkStyle } from './styles/info-pane-item-external-link-style';

export const InfoPaneItemExternalLink = ({
  onClick,
  text,
  ariaLabel,
  className,
}) => {
  const classes = useDefaultStyles(getInfoPaneItemExternalLinkStyle);

  return (
    <button
      className={classnames(classes.container, className)}
      aria-label={ariaLabel || text}
      onClick={onClick}
    >
      <div className={classes.linkIcon} />
      <div className={classes.linkText}>
        {text}
      </div>
    </button>
  );
};

InfoPaneItemExternalLink.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
};

InfoPaneItemExternalLink.defaultProps = {
  ariaLabel: '',
  className: '',
};
